import React, { useState, useEffect } from 'react';
import Lightbox from './Lightbox'; // Importa el componente de Lightbox
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEarth, faMobileAlt } from '@fortawesome/free-solid-svg-icons';

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [filter] = useState('All'); // Estado para el filtro de categoría
  const [visibleProjects, setVisibleProjects] = useState([]); // Estado para los proyectos visibles
  const [showAnimation, setShowAnimation] = useState(false); // Estado para la animación de la tarjeta

  const projects = [
    { title: 'Curiosidades de Cine', thumbnail: 'thumbnails/webCuriosidadesdeCine.png', descriptionShort: 'Página de curiosidades del mundo del cine.', descriptionLarge: 'Página creada con <b>Wordpress 6.8</b> y actualizada con nueva información mensualmente.', category: 'web', url: 'http://www.curiosidadesdecine.es', insta: 'https://www.instagram.com/curiosidadesdecine.es/' },
    { title: 'Framegonz', thumbnail: 'thumbnails/webFramegonz.png', descriptionShort: 'Este sitio.', descriptionLarge: 'Web con diseño responsive desarrollada en <b>React</b>.', category: 'web' },
    { title: 'Calculadora de Hipotecas', thumbnail: 'thumbnails/appCalculadoraDis.png', descriptionShort: 'Calculadora de Hipotecas.', descriptionLarge: 'Aplicación para hacer un cálculo aproximado de cuotas de hipotecas.<br/>App nativa en Java con Android Studio.<br/><br/><b>DESCONTINUADA</b>', category: 'app' },
    { title: 'Calculadora de Hipotecas 2', thumbnail: 'thumbnails/appCalculadora2.png', descriptionShort: 'Calculadora de Hipotecas 2.0.', descriptionLarge: 'Nueva aplicación para hacer un cálculo aproximado de cuotas de hipotecas.<br/>Desarrollada en React Native usando entorno EXPO.', urlplaystore: 'https://play.google.com/store/apps/details?id=com.framegonz.calculadora', category: 'app' },
    { title: 'Curiosidades de Cine', thumbnail: 'thumbnails/appCuriosidades.png', descriptionShort: 'App de Curiosidades de Cine.', descriptionLarge: 'Aplicación tipo Webview para Curiosidades de Cine.<br/>Desarrollada en React Native usando el entorno EXPO.<br/>Disponible para Android.', urlplaystore: 'https://play.google.com/store/apps/details?id=com.framegonz.curiosidadesdecine', category: 'app' },
    { title: 'Bonos Premium', thumbnail: 'thumbnails/appBonosPremium.png', descriptionShort: 'App para BonosPremium S.L.', descriptionLarge: 'Aplicación tipo Webview para la empresa BonosPremium.<br/>Desarrollada en React Native usando el entorno EXPO.<br/>Disponible tanto para iOS (hasta versión 1.0.7) como Android.', urlplaystore: 'https://play.google.com/store/apps/details?id=com.bonospremium.myapp', urlappstore: 'https://apps.apple.com/es/app/bonospremium/id6670571620', category: 'app' },
    // { title: 'ForgeQR', descriptionShort: 'Generador de Códigos QR', descriptionLarge: 'Aplicación que permite generar códigos QR estáticos o dinámicos<br/>Desarrollada en React Native usando el entorno EXPO.<br/>Disponible para Android.', urlplaystore: 'https://play.google.com/store/apps/details?id=com.bonospremium.myapp', category: 'app' }
  ];

  projects.sort((a, b) => {
    if (a.category === b.category) {
      return a.title.localeCompare(b.title); // Ordenar por título si las categorías son iguales
    }
    return b.category.localeCompare(a.category); // Ordenar por categoría
  });

  // Función para manejar el filtrado con animación
  const handleFilter = (selectedFilter) => {
    // Desactiva la animación antes de cambiar el filtro
    setShowAnimation(false);

    // Retrasa la actualización de los proyectos visibles para que se note el cambio de clase CSS
    setTimeout(() => {
      const visible = selectedFilter === 'All'
        ? projects
        : projects.filter(project => project.category === selectedFilter);

      setVisibleProjects(visible);
      // Activa la animación una vez que se han cargado los nuevos proyectos
      setShowAnimation(true);
    }, 100); // Se aplica un pequeño retraso para asegurarse que las clases CSS cambien
  };

  useEffect(() => {
    // Mostrar todos los proyectos al cargar la página por primera vez
    handleFilter(filter);
  }, [filter, handleFilter]);

  // Función para abrir el lightbox
  const openLightbox = (project) => {
    setSelectedProject(project);
  };

  // Función para cerrar el lightbox
  const closeLightbox = () => {
    setSelectedProject(null);
  };

  return (
    <section id="projects">
      <div id="projects-content">
        <h2>Proyectos realizados</h2>
        <br/>
        {/* Botones de filtrado */}
        <div className="category-buttons">
          <button onClick={() => handleFilter('All')}>Todo</button>
          <button onClick={() => handleFilter('app')}>Aplicaciones</button>
          <button onClick={() => handleFilter('web')}>Webs</button>
        </div>

        {/* Muestra los proyectos filtrados */}
        <div className={`projects-grid ${showAnimation ? 'animate' : ''}`}>
          {visibleProjects.map((project, index) => (
            <div 
              className={`project-card ${showAnimation ? 'visible' : ''}`} 
              key={index} 
              onClick={() => openLightbox(project)}
            >
              <h3>{project.title}</h3>
              {project.thumbnail && (
                <img src={project.thumbnail} alt="Thumbnail" className="thumbnail" />
              )}
              <p dangerouslySetInnerHTML={{ __html: project.descriptionShort }}></p>
              {project.category === 'web' && (
                <FontAwesomeIcon icon={faEarth} className="project-icon"/>
              )}
              {project.category === 'app' && (
                <FontAwesomeIcon icon={faMobileAlt} className="project-icon" />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Mueve el Lightbox fuera del contenedor de proyectos */}
      {selectedProject && <Lightbox project={selectedProject} closeLightbox={closeLightbox} />}
    </section>
  );
};

export default Projects;